import { Divider, Tag } from "antd";
import { Landmark } from "lucide-react";

import type { BusinessEntityDetailVO } from "@/api/entities/type";
import { useDict } from "@/hooks/useDict";
import { cn } from "@/lib/cn";
import { emptyPlaceholder } from "@/utils";

import { CATEGORY_TAG_COLOR } from "../constants";

/** 根据 categoryNew dict_code 取头像渐变类名 */
const getCategoryGradientClass = (categoryNew?: string): string => {
  const key = categoryNew?.includes("individual") ? "individual" : "company";
  return key === "individual"
    ? "bg-linear-to-br from-orange-400 via-orange-500 to-amber-500"
    : "bg-linear-to-br from-blue-400 via-blue-500 to-indigo-500";
};

/** 根据 categoryNew dict_code 取 Tag 颜色 */
const getCategoryTagColor = (categoryNew?: string): string | undefined => {
  if (!categoryNew) return undefined;
  if (categoryNew.includes("individual")) return CATEGORY_TAG_COLOR.individual;
  if (categoryNew.includes("company")) return CATEGORY_TAG_COLOR.company;
  return undefined;
};

/** 工商实体详情顶部信息名片 */
export const EntityHeaderCard = ({ detail }: { detail: BusinessEntityDetailVO | null }) => {
  const { getDictLabel } = useDict();
  /** 企业分类展示文案 */
  const categoryLabel = getDictLabel("businessEntityCategoryNew", detail?.categoryNew);
  /** 经营状态展示文案 */
  const statusLabel = getDictLabel("businessEntityNewStatus", detail?.newStatus);

  return (
    <div className="flex items-center gap-4 p-3 bg-slate-50 rounded-xl border">
      <div
        className={cn(
          "w-14 h-14 rounded-xl flex items-center justify-center text-white shadow-sm shrink-0",
          getCategoryGradientClass(detail?.categoryNew),
        )}
      >
        <Landmark className="w-6 h-6" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1 flex-wrap">
          <h3 className="font-bold text-lg truncate m-0">{emptyPlaceholder(detail?.name)}</h3>
          {detail?.categoryNew && (
            <Tag
              bordered
              color={getCategoryTagColor(detail.categoryNew)}
              className="text-[10px] m-0 border-0"
            >
              {categoryLabel}
            </Tag>
          )}
          {detail?.newStatus && (
            <Tag bordered className="text-[10px] m-0">
              {statusLabel}
            </Tag>
          )}
        </div>
        <div className="flex items-center gap-3 text-xs text-slate-500 flex-wrap">
          <span>信用代码</span>
          <span className="font-mono">{detail?.creditNo ?? ""}</span>
          {detail?.econKind && (
            <>
              <Divider type="vertical" className="h-3 m-0" />
              <span>{detail.econKind}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
